<div class="scheduled-report-list">
  @if (scheduledReports.length || isActiveSearch) {
    <div class="search-container">
      <rkt-table-search
        (changed)="onSearch($event)"
        placeholder="Search..."
        class="document-search"
        [disabled]="loading"
      ></rkt-table-search>
      <button rktButton [disabled]="!!(loading | accessControl | async)" (click)="createScheduledReport()">Schedule a Report</button>
    </div>
    @for (scheduledReport of scheduledReports; track scheduledReport) {
      <div class="scheduled-report-item">
        <div class="report-details">
          <div class="report-title">
            <div class="report-name">{{ scheduledReport.name | titlecase }}</div>
            <div class="report-recurrence">
              <rkt-icon name="wall-clock" class="rocket-icon"></rkt-icon>
              <div class="scheduler-type">
                <span class="scheduler-type-label">{{ scheduledReport.schedulerType | titlecase }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="report-actions">
          <button
            class="file-icon"
            (click)="onDeleteScheduledReport(scheduledReport)"
            [disabled]="false | accessControl | async"
            title="Delete Report"
          >
            <rkt-icon name="trash" class="rocket-icon rocket-trash"></rkt-icon>
          </button>
          <button
            class="file-icon"
            (click)="onUpdateScheduledReport(scheduledReport)"
            [disabled]="false | accessControl | async"
            title="Update Report"
          >
            <rkt-icon name="edit" class="rocket-icon"></rkt-icon>
          </button>
        </div>
      </div>
    }
  } @else {
    @if (!loading) {
      <div class="empty-state">
        <div class="image"></div>
        <div class="message">Looks like there are no reports scheduled at the moment.</div>
        <div class="sub-message">Create & schedule one now!</div>
        <button rktButton (click)="createScheduledReport()">Schedule a Report</button>
      </div>
    }
    @if (loading) {
      @for (i of [].constructor(10); track i) {
        <div class="scheduled-report-item loading-placeholder"></div>
      }
    }
  }
</div>
